{
  "APP_NAME": "Insured Portal UI",
  "About": "About",
  "Profile": "Profile",
  "Bop Quote": "Bop Quote",
  "Hello world !": "Hello world !",
  "Home": "Quote Summary",
  "Payer Info": "Payer Information",
  "Success": "Success",
  "Logged in as": "Logged in as",
  "Login": "Login",
  "Logout": "Logout",
  "Password": "Password",
  "Password is required": "Password is required",
  "Username": "Username",
  "Username is required": "Username is required",
  "Username or password incorrect.": "Username or password incorrect.",
  "Remember me": "Remember me",
  "Version": "Version",
  "Access": {
    "accessDenied": "You do not have permission to access this page."
  }
}
